import React from 'react';

export interface CardSkeletonProps {
  count?: number;
  height?: number | string;
  variant?: 'radar' | 'jira' | 'slack' | 'github' | 'gmail' | 'agents' | 'default';
}

export const CardSkeleton: React.FC<CardSkeletonProps> = ({
  count = 1,
  height = 110,
  variant = 'default',
}) => {
  return (
    <div
      role="status"
      data-testid="card-skeleton"
      style={{ display: 'flex', flexDirection: 'column', gap: 12, width: '100%' }}
    >
      <span className="sr-only">Cargando…</span>
      {Array.from({ length: count }).map((_, idx) => (
        <div
          key={idx}
          aria-hidden
          className="z-skeleton-card"
          style={{
            height: typeof height === 'number' ? `${height}px` : height,
            borderRadius: 16,
            background: 'var(--z-surface)',
            border: 'none',
            padding: '16px 18px',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          {/* Shimmer overlay */}
          <div
            style={{
              position: 'absolute',
              inset: 0,
              background:
                'linear-gradient(90deg, transparent 0%, var(--z-fill-2) 50%, transparent 100%)',
              animation: 'zshimmer 1.8s infinite',
            }}
          />

          {/* Header Row */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div
              style={{ width: 18, height: 18, borderRadius: 5, background: 'var(--z-fill-2)' }}
            />
            <div
              style={{ width: 75, height: 14, borderRadius: 4, background: 'var(--z-fill-2)' }}
            />
            <div
              style={{ width: 65, height: 18, borderRadius: 99, background: 'var(--z-fill-2)' }}
            />
            <div
              style={{
                marginLeft: 'auto',
                width: 45,
                height: 12,
                borderRadius: 4,
                background: 'var(--z-fill-2)',
              }}
            />
          </div>

          {/* Title Lines */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6, margin: '6px 0' }}>
            <div
              style={{ width: '88%', height: 14, borderRadius: 4, background: 'var(--z-fill-2)' }}
            />
            <div
              style={{ width: '62%', height: 12, borderRadius: 4, background: 'var(--z-fill-2)' }}
            />
          </div>

          {/* Footer Line */}
          {variant !== 'radar' && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <div
                style={{ width: 50, height: 12, borderRadius: 4, background: 'var(--z-fill-2)' }}
              />
              <div
                style={{ width: 80, height: 12, borderRadius: 4, background: 'var(--z-fill-2)' }}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
